import { omniaResolve } from "../../promises"
import { createMap } from "../../utils/array"
import { IGlobalSetting, SaveGlobalSetting } from "../types"

interface Context {
    holdingId: number
    userId: number
    settings: IGlobalSetting[]
    save: SaveGlobalSetting
}

export function createGlobalSettings(context: Context = { holdingId: 0, userId: 0, settings: [], save: undefined }) {

    const { holdingId, userId, save } = context
    const settings = createMap(context.settings ?? [], s => s.Key)

    return {
        get,
        set
    }

    /**
     * Returns the value for the first setting with a key in "keys"
     * We are accepting multiple keys to make it easier to rename keys
     * The caller can then call e.g. get("new name", "original name")
     */
    function get<T = any>(...keys: string[]): T {

        for (const key of keys) {

            if (settings.has(key)) {
                return settings.get(key)?.Value as T
            }

        }

        return null

    }

    function set<T = any>(key: string, value: T, userLevel?: boolean) {

        const setting = settings.get(key)

        if (setting) {

            setting.Value = value

        } else {

            settings.set(key,
                {
                    HoldingId: userLevel ? null : holdingId,
                    UserId: userLevel ? userId : null,
                    Key: key,
                    Value: value
                }
            )

        }

        return save
            ? save(userLevel ? userId : null, !userLevel ? holdingId : null, key, value)
            : omniaResolve()

    }

}
